import { pipe } from 'fp-ts/lib/function';
import { Effect } from 'effect';
import { Product as ProductService } from '@fixtuur/gift-client';
/**
 * TEMPORARY
 *
 * What actually is this and where does it live?
 *
 * It's not an API concept. It shouldn't be here. ProductsPerPart isn't a thing.
 *
 * It exists solely to pull products out of a configurator definition so that we
 * can turn them into product cards to display in the VC experience. The cards need
 * to reflect the current set of filters and other selections.
 *
 * It does two things in order to achieve that:
 * - pulling productIds per part out of a Configurator Definition and the given Options
 * - hydrating the productIds into complete Api.Products,
 *
 * Proposed refactor: Fixtuur.ConfigurationProduct.FromProductOptions (which calls this) is
 * what actually cares about the fact that we're listing products per part. The API domain
 * should only be involved at the stage of batch hydrating a list of products.
 * Hence this should probably be two separate functions in the API domain, which are called
 * and put together by Fixtuur.ConfigurationProduct. So:
 * - Move the ownership of listing products per part into Fixtuur.ConfigurationProduct
 * - It should call out to Api.ConfiguratorDefinition to get the skus per part
 * - It should call out to Api.Product to hydrate products where needed
 *
 * TODO: the above refactor
 */
const tuple = (a, b) => [a, b];
export const makeProductIdsPerPart = (cd, options) => {
    const productPartEntries = pipe(Object.entries(cd.partsMap).map(([key, value]) => [key, value.productProperty]));
    // productIds for each part
    // eg {'basin': [ 'sku1', 'sku2', 'sku3' ]}
    return pipe(productPartEntries.map(([partKey, property]) => {
        return [partKey, options[property] ?? []];
    }), x => Object.fromEntries(x));
};
export const fromProductPropertiesButEffect = (tenantId, configuratorDefinition, options) => Effect.gen(function* () {
    const productService = yield* ProductService.ProductService;
    const products = yield* productService.getByTenant(tenantId);
    const productIdsPerPart = makeProductIdsPerPart(configuratorDefinition, options);
    return Object.fromEntries(Object.entries(productIdsPerPart).map(([partKey, productIds]) => {
        return tuple(partKey, products.filter(p => productIds.includes(p.canonicalId)));
    }));
});
